import axios from "axios";

export interface OrgListItem {
  org_id: string;
  name: string;
  category: string | null;
  status: string;
  active_systems: number;
}

interface OrgListResponse {
  orgs?: OrgListItem[];
}

const OrgService = {
  listOrgs: async (): Promise<OrgListItem[]> => {
    const res = await axios.get<OrgListResponse>("/api/proxy/orgs/list");
    return res.data.orgs ?? [];
  },

  createOrg: async (orgName: string, category: string) => {
    // Backend's CreateOrgRequest (app/models.py) expects `category`, not
    // `category_id` - the mismatch meant category never actually reached
    // the backend, causing a 422 "field required" on every submission.
    const res = await axios.post("/api/proxy/orgs", {
      org_name: orgName,
      category: category,
    });
    return res.data;
  },

  deleteOrg: async (orgId: string) => {
    const res = await axios.delete(`/api/proxy/orgs/${orgId}`);
    return res.data;
  },
};

export default OrgService;
